import { FC } from 'react';

import { Modal } from '../../../shared/ui';

import { MacDeckSelectContent } from './mac-deck-select-content';

export interface IMacDeckSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  sendMacCardsOpen?: (data: {
    show: boolean;
    cover: string;
    color: string;
    result: { name: string; value: string[] };
  }) => void;
}

export const MacDeckSelectModal: FC<IMacDeckSelectModalProps> = ({ isOpen, onClose, onConfirm, sendMacCardsOpen }) => (
  <Modal isOpen={isOpen} title="МАК колоды" onClose={onClose}>
    <MacDeckSelectContent onClose={onClose} onConfirm={onConfirm} sendMacCardsOpen={sendMacCardsOpen} variant="modal" />
  </Modal>
);
